<template>
  <el-form :model="formData" class="search-box">
    <div class="select_from_store_name" v-if="storeSearch">
      <label-input
        label="门店名称"
        placeholder="请输入门店名称"
        v-model="formData.storeName"
        type="autocomplete"
        width="254px"
      ></label-input>
    </div>
    <div class="select_from_store_name">
      <label-input label="职员名称" placeholder="请输入职员名称" width="180px" v-model="formData.name"></label-input>
    </div>
    <div class="select_from_user_name">
      <label-input label="登录名" placeholder="请输入登录名" width="200px" v-model="formData.userName"></label-input>
    </div>
    <div class="select_from_user_name">
      <el-select v-model="formData.role" placeholder="请选择角色" clearable>
        <el-option v-for="(value, key) in roleTypeOptions" :key="key" :label="value" :value="key"></el-option>
      </el-select>
    </div>
    <el-form-item class="fl">
      <el-button type="info" plain @click="onSubmit" class="search-btn">查询</el-button>
    </el-form-item>
    <!--    <el-form-item class="fl" v-if="exportRender">-->
    <!--      <el-button type="info" plain @click="onexport" class="search-btn">导出</el-button>-->
    <!--    </el-form-item>-->
  </el-form>
</template>

<script>
import labelInput from '@/components/global/form/labelInput';
import { hasPermission, transformParamToUrl, downloadByLink, downloadByIframe } from '@/util/index';
import Constant from '@/lib/constant';
const baseRole = Constant.RoleList;

const roles = ['remote_trial_pharmacist', 'store_manager', 'clerk', 'pharmacist', 'regional_head'];
const storeManageRoles = ['remote_trial_pharmacist', 'store_manager', 'clerk', 'pharmacist'];

export default {
  name: 'breadTab',
  components: { labelInput },
  props: {
    searchData: {
      type: Object,
      default: () => {
        return {
          name: '',
          storeName: '', //
          userName: '',
          role: ''
        };
      }
    }
  },
  data() {
    return {
      formData: {
        name: '', // 店员名称
        storeName: '', // 门店名称
        userName: '', // 登陆名
        role: ''
      }
    };
  },
  watch: {
    searchData: {
      handler: function (val) {
        this.formData = val;
      },
      deep: true
    }
  },
  computed: {
    storeSearch() {
      return hasPermission([baseRole.a, baseRole.c]);
    },
    roleTypeOptions() {
      return Object.keys(Constant.roleType)
        .filter(role => (this.$checkPower('a,c') ? roles : storeManageRoles).includes(role))
        .reduce((roles, role) => ({ ...roles, [role]: Constant.roleType[role] }), {});
    }
  },
  methods: {
    exportRender() {
      let per = [baseRole.a, baseRole.c, baseRole.d];
      return hasPermission(per);
    },
    onSubmit() {
      this.$emit('search', this.formData);
    },
    addStore() {
      this.$router.push('/staffManagement/addStaff');
    },
    // 导出数据
    onexport() {
      this.onSubmit();
      console.log(this.formData);
      let { name, storeName, userName } = this.formData;
      const data = {
        storeName: storeName || null,
        name: name || null,
        userName: userName || null
      };
      const baseUrl = `${Util.getGwRoot}drugstore/1.0/export_user`;
      const str = transformParamToUrl(data);
      console.log('str', str);
      const openUrl = `${baseUrl}?${str}`;
      console.log('openUrl', openUrl);
      downloadByIframe(openUrl, '职员数据');
    }
  }
};
</script>
<style lang="scss" scoped>
.add-btn {
  float: left;
  margin-right: 16px;
  border: 1px solid #ebb436;
  text-align: center;
  width: 178px;
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  cursor: pointer;
  span {
    color: #ebb436;
    font-weight: 500;
  }
}
.select_from_store_name {
  float: left;
  margin-right: 16px;
}
.select_from_user_name {
  float: left;
  margin-right: 16px;
}
.fl {
  float: left;
  margin-right: 16px;
}
.fr {
  float: right;
  margin-right: 16px;
}
.last {
  margin-right: 0;
}
.link {
  width: 176px;
  background: #fff !important;
  color: #bdbdbd !important;
  text-align: left;
  padding: 12px 12px;
  span {
    i {
      float: right;
    }
  }
  &:hover {
    color: #bdbdbd !important;
  }
}
.search-btn {
  background: #ffffff !important;
  color: #1e8dff !important;
  height: 38px !important;
  width: 80px !important;
  border: 1px solid #1e8dff !important;
  &:hover {
    background: rgba(68, 184, 91, 0.1) !important;
  }
}
</style>
